module.exports = __webpack_public_path__ + "img/shuang-bao-logo.e1a72d2a.jpg";